/** @format */

import { createAction } from 'redux-actions';
import {
	getCountries,
	getCityByCountryCode,
	getFilterKeyWord
} from 'apis/misc';
import { getAllMeetupListByCity } from 'apis/meetup';
import { convertToTimestamp } from 'utils/utils';
import types from './types';

export const addSystemRequest = createAction(types.ADD_LOADING_REQUEST, () => ({
	loading: true
}));
export const removeSystemRequest = createAction(
	types.REMOVE_LOADING_REQUEST,
	() => ({ loading: false })
);

export const setSelectedCountry = createAction(
	types.SET_SELECTED_COUNTRY,
	(selectedCountry) => ({ selectedCountry })
);
export const setSelectedCities = createAction(
	types.SET_SELECTED_CITY,
	(selectedCities) => ({ selectedCities })
);

export const resetFilter = createAction(
	types.RESET_FILTER,
	() => async (dispatch, _) => {
		dispatch(setSelectedCities([]));
		dispatch(setTitle(''));
	}
);

export const setTitle = createAction(types.SET_TITLE, (title) => ({ title }));

export const fetchSelectedCountry = createAction(
	types.FETCH_SELECTED_COUNTRY,
	(selectedCountry) => (dispatch, getState) => {
		dispatch(setSelectedCountry(selectedCountry));
		dispatch(fetchCities());
	}
);

export const fetchCountries = createAction(
	types.FETCH_COUNTRIES,
	() => async (dispatch, getState) => {
		dispatch(addSystemRequest());
		try {
			const { data } = await getCountries();
			dispatch(removeSystemRequest());
			return { countries: data.countries };
		} catch (e) {
			console.log('e: ', e);
			dispatch(removeSystemRequest());
			return { countries: {} };
		}
	}
);

export const fetchCities = createAction(
	types.FETCH_CITIES,
	() => async (dispatch, getState) => {
		dispatch(addSystemRequest());
		try {
			const { dashboard } = getState();
			const { data } = await getCityByCountryCode(
				dashboard.filter.selectedCountry.ID
			);
			dispatch(removeSystemRequest());
			return { cities: data.cities };
		} catch (e) {
			console.log('e: ', e);
			dispatch(removeSystemRequest());
			return { cities: {} };
		}
	}
);

export const fetchMeetups = createAction(
	types.FETCH_MEETUPS,
	(params) => async (dispatch, getState) => {
		dispatch(addSystemRequest());
		const { dashboard } = getState();
		try {
			const treatmentIDs =
				params && params.treatment
					? params.treatment.map((item) => item.ID)
					: [];
			const response = await getAllMeetupListByCity(
				{
					...(dashboard.filter.title && { title: dashboard.filter.title }),
					...(dashboard.filter.selectedCities &&
						dashboard.filter.selectedCities.length > 0 && {
							cities: JSON.stringify(
								dashboard.filter.selectedCities.map((item) => item.ID)
							)
						}),
					...(params &&
						params.meetup &&
						params.meetup.length > 0 && {
							categories: JSON.stringify(params.meetup.map((item) => item))
						}),
					...(params && params.sorter && { sort: params.sorter.ID }),
					...(params &&
						params.dateStart && {
							startAt: convertToTimestamp(params.dateStart)
						}),
					...(params &&
						params.dateEnd && { endAt: convertToTimestamp(params.dateEnd) }),
					...(treatmentIDs.includes('isHostTreat') && { isTreated: true }),
					...(treatmentIDs.includes('isReward') && { isRewarding: true })
				},
				dashboard.filter.selectedCountry.ID
			);
			dispatch(removeSystemRequest());
			return { meetups: response.data.meetups };
		} catch (e) {
			console.log('e: ', e);
			dispatch(removeSystemRequest());
			return { meetups: [] };
		}
	}
);

export const fetchFilterKeyWord = createAction(
	types.FETCH_FILTER_KEYWORD,
	() => async (dispatch, getState) => {
		const response = await getFilterKeyWord();
		const tags = response.data.body.tags.map((item) => ({
			value: item,
			label: item,
			url: `?title=${item}`
		}));
		return { tags };
	}
);
